export default "__VITE_ASSET__wXSZp4UV__"